import Compressor from 'compressorjs';
import { DRPP, PMI } from './globalConst';

export const options = {
  quality: 0.6,
};

export const isDrpp = (_isDrpp = '') => _isDrpp === DRPP;

export const isNumAdhesion = (numAdhesion = '', isdrpp = '') => {
  if (numAdhesion === PMI) return true;
  return (
    numAdhesion === 'AS4' &&
    ['Numéro Adhésion', "Numéro d'adhésion"].includes(isdrpp)
  );
};

export const asyncForEach = async (array: any[], callback: any) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

export const blobToBase64 = (blob: any) => {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

/* istanbul ignore next */
export const compress = (file: any) =>
  new Promise(function (resolve, reject) {
    new Compressor(file, {
      ...options,

      success(result) {
        resolve(result);
      },
      error(err) {
        reject(err);
      },
    });
  });

export const PHYSIQUE_DOCS = [
  'CERTIFICAT DE SCOLARITE POUR L EXERCICE EN COURS',
  'COMPTE RENDU ET LE CLICHE DE LA RADIO PANORAMIQUE',
  'L EXTRAIT D ACTE DE NAISSANCE',
  'LA RADIO DE TRAITEMENT DE LA RACINE REALISEE',
  'LES PPM DES MEDICAMENTS ACHETES',
  'LES PPM ET PROSPECTUS DES MEDICAMENTS ACHETES',
  'LES PROSPECTUS DES MEDICAMENTS ACHETES',
  'PPM ET PROSPECTUS CONSOMMES A L HOSPITALISATION',
  'RADIOS AVANT ET APRES POSE DE LA PROTHESE DENTAIRE',
  'ORIGINAL ATTESTATION NON AFFILIATION CNSS OU CNOPS',
  "MANQUE DATE D'EXPIRATION SUR PPM",
  'CLICHE DE RADIO AVANT POSE DE LA PROTHESE',
  'ORIGINAL DE LA FACTURE',
  'RADIOS AVANT EXTRACTION',
  'CLICHES DES RADIOS AVANT ET APRES',
  'RADIO DE FAUX MOIGNON',
  'DOSSIER ORIGINAL',
  'FOURNIR LES RADIOS DES DENTS CONCERNEES',
  'la déclaration maladie dûment renseignée par les dates des extractions dentaires accordées.',
  'une déclaration maladie dentaire dûment renseignée par les soins réalisés.',
  'la déclaration maladie dûment renseignée par la nature exacte des soins réalisés',
  'la déclaration maladie dûment renseignée par le numéro de(s) dent(s)  sur le schéma dentaire',
  'la déclaration maladie dûment renseignée par la cotation des soins réalisés',
  'le devis du 1er semestre',
  'la déclaration maladie dûment renseignée par la date de la réalisation de la prothèse dentaire',
  'la facture de réalisation de la prothèse dentaire dûment remplie sur le devis initial',
  'la déclaration maladie dûment renseignée par le nombre des dents sur le stellite',
  'la déclaration maladie dûment renseignée par le semestre réalisé',
  'la déclaration maladie dûment renseignée par le montant des soins réalisés',
  "l'attestation d'inactivité ou de non assurance du conjoint",
  "le certificat de scolarité pour l'exercice en cours",
  "l'extrait d'acte de naissance",
  'une attestation adulaire',
  'le certificat de célibat',
  'une attestation de non affiliation à la CNSS',
  "une copie légalisée de l'acte de mariage",
  'une attestation adulaire ou une copie du jugement justifiant la prise en charge des enfants',
  'un bulletin rectificatif du nouveau né',
  'un bulletin rectificatif ',
  'la déclaration maladie dûment renseignée par le nom et le cachet du médecin traitant dans la partie réservée à cet effet.',
  'la déclaration maladie dûment renseignée par le nom et le cachet du pharmacien dans la partie de la déclaration maladie réservée à cet effet.',
  'la déclaration maladie dûment renseignée par la prescription médicale ',
  'la déclaration maladie dûment renseignée par la prescription médicale des séances de rééducation',
  'la déclaration maladie dûment renseignée par la prescription médicale des analyses ',
  'la déclaration maladie dûment renseignée par la prescription médicale des radios effectuées',
  'les PPM des médicaments achetés',
  'les prospectus des médicaments achetés',
  'les PPM et prospectus des médicaments achetés',
  'les résultats des analyses',
  "le compte rendu de l'échographie",
  'le compte rendu de la radio ou du scanner  réalisés',
  'le compte rendu opératoire',
  "le compte rendu d'hospitalisation",
  "la facture d'hospitalisation dûment renseignée par son mode de règlement.",
  "la note d'honoraires du chirurgien",
  "l'ordonnance médicale dûment renseignée par la durée de traitement des médicaments prescrits",
  "la facture globale de l'hospitalisation",
  'une copie lisible de la feuille mutuelle et des pièces justificatives',
  "la déclaration maladie dûment renseignée par le nombre de 'B' biologique",
  'la déclaration maladie dûment renseignée par le degré de dioptrie',
  'la déclaration maladie dûment renseignée par le nom de la personne malade avec le cachet et la signature du médecin traitant',
  "l'ordonnance médicale dûment renseignée par le numéro de référence de la préparation",
  "le tracé de l'ECG",
  'le compte rendu de la mammographie',
  'le résultat du test cutané',
  "le résultat de l'anapath",
  'le devis des séances de rééducation établi par le kinésithérapeute',
  "les ppm et prospectus consommés lors de l'hospitalisation",
  "le compte rendu de l'audiogramme",
  'un reçu des honoraires perçu par le médecin traitant',
  "le compte rendu de l'examen anatomo-pathologique",
];
